class BookmarkView {
  constructor() {
    this._parentEl = document.querySelector('#btn-bookmark');
    this._handlers = {};

    // 1) Add event listeners
    this._parentEl.addEventListener(
      'click',
      this._publishEvent.bind(this, 'click')
    );
  }

  registerHandler(type, handler) {
    // 1) Create empty array if no callbacks have been registered for this type
    if (!this._handlers[type]) this._handlers[type] = [];

    // 2) Register handler
    this._handlers[type].push(handler);
  }

  _publishEvent(type, data = null) {
    // 1) Return if no handlers are registered for this event type
    if (!this._handlers[type]) return;

    // 2) Run all registered handlers and pass along data
    this._handlers[type].forEach((handler) => {
      handler(data);
    });
  }

  render(isBookmarked) {
    // 1) Clear parent container
    this._parentEl.innerHTML = '';

    // 2) Generate markup to be added to the DOM
    const markup = `
      <button class="bookmark ${isBookmarked ? 'is-bookmarked' : ''}">
        <svg class="bookmark__icon">
          <circle class="bookmark__icon-bg" cx="28" cy="28" r="28" />
          <path class="bookmark__icon-symbol" d="M23 19v18l5-5.058L33 37V19z" />
        </svg>

        <span class="bookmark__label">Bookmark</span>
      </button>
    `;

    // 3) Add elements to the DOM
    this._parentEl.insertAdjacentHTML('afterbegin', markup);
  }
}

export default new BookmarkView();
